// extracted by mini-css-extract-plugin
module.exports = {"toggleSelector":"ToggleSelector_toggleSelector__qZelq","wrapper":"ToggleSelector_wrapper__2EHgf","button":"ToggleSelector_button__21Y71","active":"ToggleSelector_active__2ipf7"};